import { useNavigate } from "react-router-dom";

import { getErrorMessage } from "@repo/system";
import { T } from "@repo/transifex";

import { DisplayErrorMessage } from "./display-error-message";
import { DialogError } from "./DialogError";
import { Button } from "./Button";

type OrderCreateErrorDialogProps = {
  error: unknown;
  open: boolean;
  reset: () => void;
};

export const OrderCreateErrorDialog = ({
  error,
  open,
  reset
}: OrderCreateErrorDialogProps) => {
  const navigate = useNavigate();

  if (!open) return null;

  const handleClose = () => {
    navigate("/pos");
    reset();
  };

  return (
    <DialogError
      backdropVariant="error"
      className="w-full max-w-md"
      error={
        <DisplayErrorMessage
          error={error}
          fallback={
            error ? getErrorMessage(error) : <T _str="Could not create order" />
          }
        />
      }
      hideSupport
      onOutsideClick={handleClose}
    >
      <Button className="w-full" onClick={handleClose} variant="secondary">
        <T _str="Close" />
      </Button>
    </DialogError>
  );
};
